<template>
    <v-responsive :aspect-ratio="16 / 9" class="grey-f7" ref="container">
        <template v-if="initiated">
            <template v-if="type == LECTURE_VIDEO_TYPES.UTUBE.value">
                <video-utube v-bind="{ width, height }" />
            </template>
            <template v-if="type == LECTURE_VIDEO_TYPES.VIMEO.value">
                <video-vimeo v-bind="{ width, height }" />
            </template>
        </template>
        <v-fade-transition>
            <v-overlay v-show="!initiated" absolute color="transparent">
                <v-progress-circular size="100" width="5" color="primary" indeterminate />
            </v-overlay>
        </v-fade-transition>
    </v-responsive>
</template>

<script>
import { mapState } from "vuex";
import { LECTURE_VIDEO_TYPES } from "@/store/lecture";

import VideoUtube from "./video/video-utube.vue";
import VideoVimeo from "./video/video-vimeo.vue";

export default {
    components: {
        VideoUtube,
        VideoVimeo,
    },
    data: () => ({
        LECTURE_VIDEO_TYPES,

        width: undefined,
        height: undefined,
        initiated: false,
    }),
    computed: {
        ...mapState("lecture", ["lecture"]),
        type() {
            return this.lecture?.video?.type;
        },
    },
    methods: {
        setSize() {
            const intervalId = setInterval(() => {
                let containerEl = this.$refs["container"]?.$el;
                if (!containerEl) return;
                const [{ width, height }] = containerEl.getClientRects();
                this.width = width;
                this.height = height;
                this.initiated = true;
                clearInterval(intervalId);
            }, 10);
        },
    },
    mounted() {
        this.setSize();
        window.addEventListener("resize", this.setSize);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.setSize);
    },
};
</script>

<style>
</style>